var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('position:absolute;opacity:0;height:0;width:0;display:inline-block;' + _vm.font)},[_vm._v(".")])}
var staticRenderFns = []

export { render, staticRenderFns }